import React from "react";
import { Logo } from "@/components/Logo";
import { HOME_URL } from "@/lib/constants";
import { isEmbedded } from "@/lib/embed";

export const Footer = () => {
  // In embedded mode (inside an iframe on rendeavored.com, or ?embedded=1),
  // hide the app's internal site-level footer entirely so only the parent
  // site's footer is shown. Returning null on the first render avoids any
  // flash of the footer. The final-report CTA (Schedule Consultation,
  // Download PDF, Return link) lives elsewhere and is unaffected.
  if (isEmbedded()) return null;

  return (
    <footer className="border-t border-white/10 rd-bg" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          {/* Footer logo -> main public website (same tab) */}
          <a href={HOME_URL} data-testid="footer-logo-link" className="inline-flex">
            <Logo height={30} />
          </a>
          <p className="text-white/50 text-sm mt-3 max-w-md">
            TeamBuilder AI&trade; by Rendeavored Group, LLC. Design your optimized
            global talent &amp; managed-support workforce in minutes.
          </p>
        </div>
        <div className="flex flex-col sm:items-end gap-2">
          <a
            href={HOME_URL}
            data-testid="footer-home-link"
            className="text-white/70 hover:text-white text-sm transition-colors"
          >
            Return to Rendeavored.com
          </a>
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Rendeavored Group, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
